import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function BackLiveIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m15.6 2.69867c0-.2411.2666-.38253.4594-.24492.4625.3301 1.1853.83508 1.7426 1.17187.5505.33269 1.3142.72874 1.834.99082.2235.11271.217.44741-.0106.55137-.5192.23725-1.2758.59414-1.8234.89766-.5601.31047-1.2896.7809-1.752 1.08632-.1934.12771-.4499-.01398-.45-.25019v-1.42676h-4.2c-3.93494 0-7.12489 3.19003-7.12495 7.12496 0 3.9351 3.18997 7.125 7.12495 7.125h5.4v1.35h-5.4c-4.68056 0-8.47495-3.7943-8.47495-8.475.00006-4.68052 3.79443-8.47496 8.47495-8.47496h4.2z" />
        <path d="m12 8.99984c1.9882 0 3.6 1.61186 3.6 3.59996 0 1.9883-1.6117 3.6-3.6 3.6-1.9882 0-3.59995-1.6117-3.59995-3.6.00006-1.9881 1.61185-3.59996 3.59995-3.59996z" />
      </g>
    </SVGWrapper>

  );
}

export default BackLiveIcon;
